import { InputText as UIInputText } from "@webmotors/eleanor-ui";
import type { FocusEventHandler, LegacyRef } from "react";

export type InputTextProps = {
  id?: string;
  type?:
    | "email"
    | "text"
    | "document"
    | "documentCompany"
    | "phone"
    | "mobilePhone"
    | "zipcode";
  size?: "small" | "medium" | "large";
  label?: string;
  placeholder?: string;
  className?: string;
  value?: string;
  hasError?: boolean;
  maxCharacters?: number;
  disabled?: boolean;
  auxiliarText?: string;
  rightIcon?: string;
  renderRightIcon?: boolean;
  required?: boolean;
  loading?: boolean;
  dataQA?: string;
  inputRef?: LegacyRef<HTMLInputElement> | null;
  customValidation?: {
    regexMask?: any;
    regexValidation: any;
    pattern: string;
    hasCustomValidation: boolean;
    errorMessage:
      | string
      | "Invalid value according to customValidation regex prop";
  };
  hasErrorCallback?: ({
    error,
    message,
  }: {
    error: boolean;
    message?: string;
  }) => void;
  onChange?: (event: string) => void;
  onBlur?: FocusEventHandler<HTMLInputElement>;
};

export function InputText(props: Readonly<InputTextProps>) {
  return <UIInputText {...props} data-testid="input-text" />;
}
